<template>
  <div ref="component" v-if="$preview" class="image-debugger">
    <button v-if="state.show" @click="onClick" class="image-debugger__btn">Renditions</button>
    <div class="image-debugger__links" :class="{'image-debugger__links--visible': state.toggled}">

      <template v-for="(item, index) in props.renditions">
        <a class="image-debugger__link" target="_blank" v-if="item.rendition.debugUrl" :href="item.rendition.debugUrl">rendition_{{
            item.name
          }}</a>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">

import {TImageRendition} from "~/types/other-types";

const {$preview, $secret} = useNuxtApp();
const component = ref<HTMLElement>()

const props = defineProps<{
  renditions: TImageRendition[]
}>()

type TState = {
  toggled: boolean,
  show: boolean
}

const state: TState = reactive({
  toggled: false,
  show: false
})

onMounted(() => {

  const withinA = () => {
    if (component.value) {
      const a = component.value.closest('a')
      if (!a) {
        state.show = true
      }
    }
  }

  window.requestAnimationFrame(withinA)

})

const onClick = (e) => {
  state.toggled = !state.toggled
}

</script>

<style scoped lang="postcss">
.image-debugger {
  position: absolute;
  bottom: 2px;
  right: 2px;
  z-index: 999999;

  &__btn {
    cursor: pointer;
    font-size: 10px;
    text-transform: uppercase;
    color: black;
    padding: 5px 8px;
    border-radius: 10px;
    border: 1px solid white;
    background-color: rgba(255, 255, 255, 0.5);
  }

  &__links {
    position: absolute;
    display: none;
    visibility: hidden;
    bottom: calc(100% + 2px);
    right: 0;
    font-size: 10px;
    text-transform: uppercase;
    color: black;
    padding: 5px 8px;
    border-radius: 10px;
    border: 1px solid white;
    background-color: rgba(255, 255, 255, 0.5);

    &--visible {
      display: block;
      visibility: visible;
    }
  }

  &__link {
    display: block;
    margin: 4px 0;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
